export default "__VITE_ASSET__CmTJ0Y27__"